export default {
  date: {
    y: "年",
    m: "月",
    d: "日",
  },

  time: {
    h: "小时",
    min: "分钟",
    s: "秒",
    ago: "之前",
    present: "现在",
    justNow: "刚刚",
  },

  // no data
  noData: "没有数据",
  noDataFound: "没有数据",
  checkAgain: "请再次检查或联系管理员",
  //not specified
  notSpecified: "未指定",

  //check document
  checkDocs: {
    code_0: "数字签名和 XML 不可信",
    code_1: "数字签名可信，但 XML 不可信",
    code_2: "数字签名和 XML 均可信",
  },

  people: "",
  times: "",

  dialogConfirm: {
    unsavedDataTitle: "您尚未保存数据",
    leavePageMessage: "您确定要离开此页面吗？",
    confirmDeleteMessage: "您确定要删除此数据吗？",
    confirmSaveMessage: "您确定要保存此数据吗？",

    success: "成功",
    saveSuccess: "数据已成功保存",

    error: "发生错误",
    saveFailed: "无法保存数据",

    invalidFormMessage: "请检查您输入的信息是否正确",

    leavePage: "离开此页面",
    cancelEditMessage: "您确定要取消此次编辑吗？",
  },

  dialogEditStatus: {
    recruitmentAnnouncementTitle: "招聘公告",
    reopenRecruitmentMessage: "您想重新开放此职位招聘吗？",
    editRecruitmentDateMessage: "如果您想更改招聘日期",
    manageJobMessage: "您可以在每个职位的管理页面进行设置",
    closeRecruitmentTitle: "关闭招聘",
    closeRecruitmentMessage: "您确定要关闭此次招聘吗？",
  },

  statusButton: {
    open: "开启",
    openRecruitment: "开放招聘",
    close: "关闭",
    cancel: "取消",
    confirm: "确认",
    save: "保存",
    saveData: "保存数据",
    ok: "确定",
  },

  home: {
    select: "选择您要访问的机构",
    placeholder: "搜索机构",
    nodata: "未找到您搜索的公司信息",
  }
};